<section class="relative w-full overflow-hidden py-14 " [appScrollSection]="data?.anker">
  <!-- leichter Background -->
  <div class="absolute inset-0 opacity-60 blur-2xl"></div>

  <div class="relative max-w-6xl mx-auto px-6">
   
    <div class="relative border-2 border-black p-6 overflow-visible">
      <div class="grid grid-cols-1 md:grid-cols-2 items-center">
        <!-- Left: Image -->
        <div class="relative flex justify-center md:justify-start">
          <img
            [src]="data?.image?.fields?.file?.url"
            width="1200"
            height="800"
            class="w-[500px] max-w-full h-[220px] sm:h-[280px] md:h-[320px] object-contain md:-ml-20"
            alt=""
          />
        </div>

        <!-- Right: Text + Button -->
        <div class="relative z-10 text-center md:text-left mt-10 md:mt-0">
          <div
            class="text-black font-primary text-xl sm:text-2xl md:text-3xl leading-relaxed"
            [innerHTML]="documentToHtmlString(data?.text)"
          ></div>

          <!-- Button -->
          <div class="mt-8 flex justify-center">
            <a
              class="inline-flex items-center justify-center border-2 border-black px-6 py-3 text-black font-primary font-bold uppercase tracking-wide transition-all duration-300  hover:bg-[#A4896D] hover:text-white"
              [href]="data?.button.fields?.url"
            >
              {{ data?.button.fields?.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
